import { CommunicationSearchBarComponent } from "./communication-search-bar/communication-search-bar.component"
import { MessageDetailsComponent } from "./message-details/message-details.component"
import { MessageFilterComponent } from "./communication-search-bar/message-filter/message-filter.component"
import { MessagesTableComponent } from "./messages-table/messages-table.component";
import { SuggestionDetailsComponent } from "./suggestion-details/suggestion-details.component"
import { SuggestionFilterComponent } from "./communication-search-bar/suggestion-filter/suggestion-filter.component"
import { SuggestionsTableComponent } from "./suggestions-table/suggestions-table.component"

export {
  CommunicationSearchBarComponent,
  MessageDetailsComponent,
  MessageFilterComponent,
  MessagesTableComponent,
  SuggestionDetailsComponent,
  SuggestionFilterComponent,
  SuggestionsTableComponent,
}

export const communicationsComponents = [
  CommunicationSearchBarComponent,
  MessageDetailsComponent,
  MessageFilterComponent,
  MessagesTableComponent,
  SuggestionDetailsComponent,
  SuggestionFilterComponent,
  SuggestionsTableComponent,
]
